var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('TemThree',{attrs:{"isPreview":_vm.isPreview,"isMenu":_vm.isMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }